{
  "shell.couldNotVerify.body": "We could not verify your membership right now. Please try signing in again in a moment.",
  "shell.couldNotVerify.heading": "Membership could not be verified",
  "shell.couldNotVerify.logout": "Log out",
  "shell.couldNotVerify.retry": "Try again",
  "shell.desktopSidebar.navLabel": "Side menu",
  "shell.desktopSidebar.homeLink": "To home",
  "shell.desktopSidebar.languageSwitcher.label": "Change language",
  "shell.desktopSidebar.feeOverdueMarker": "Membership fee unpaid",
  "shell.desktopSidebar.opensInNewTab": "opens in a new tab",
  "shell.footer.copy": "Oma+ — demo build, not production.",
  "shell.noMembershipBlock.benefit1": "A legal companion (Lakikaveri) for employment issues",
  "shell.noMembershipBlock.benefit2": "Leisure-time accident insurance at home and abroad",
  "shell.noMembershipBlock.benefit3": "Professional legal-expenses and liability insurance",
  "shell.noMembershipBlock.benefit4": "Thousands of online courses",
  "shell.noMembershipBlock.benefit5": "Personal career coaching",
  "shell.noMembershipBlock.benefit6": "Varied discounts on, for example, hotels, fitness benefits and cybersecurity",
  "shell.noMembershipBlock.benefitsIntro": "As a YTK Työelämä member you get:",
  "shell.noMembershipBlock.body": "You do not have a valid YTK Työelämä membership, so the service cannot be used.",
  "shell.noMembershipBlock.heading": "No YTK Työelämä membership",
  "shell.noMembershipBlock.joinLinkLabel": "ytkpalvelut.fi/liity-jaseneksi",
  "shell.noMembershipBlock.joinPrefix": "You can join YTK Työelämä at ",
  "shell.noMembershipBlock.logout": "Log out",
  "shell.menu.close": "Close menu",
  "shell.menu.cms": "CMS",
  "shell.menu.description": "Secondary menu: service navigation, language, sign-out, and CMS access.",
  "shell.menu.languagePicker.label": "Language",
  "shell.menu.languagePicker.fi": "Suomi",
  "shell.menu.languagePicker.en": "English",
  "shell.menu.languagePicker.sv": "Svenska",
  "shell.menu.legal.privacyPolicy": "Privacy policy",
  "shell.menu.legal.termsOfUse": "Terms of use",
  "shell.menu.lakikaveri.children.lakiruutu": "Lakiruutu",
  "shell.menu.lakikaveri.children.oikeusturvavakuutus": "Legal expenses insurance",
  "shell.menu.lakikaveri.children.tutustuLakikaveriin": "Learn about Lakikaveri",
  "shell.menu.lakikaveri.label": "Lakikaveri",
  "shell.menu.navLabel": "Site actions",
  "shell.menu.otaYhteytta.label": "Contact us",
  "shell.menu.palvelutEdut.children.edutAlennukset": "Benefits and discounts",
  "shell.menu.palvelutEdut.children.verkkokoulutuspalvelu": "Online training service",
  "shell.menu.palvelutEdut.label": "Membership and benefits",
  "shell.menu.signIn": "Sign in",
  "shell.menu.signOut": "Sign out",
  "shell.menu.submenuSuffix": "submenu",
  "shell.menu.tapaturmavakuutus.label": "Accident insurance",
  "shell.menu.title": "Menu",
  "shell.menu.userChip.demoBadge": "demo",
  "shell.menu.userChip.memberNumberPrefix": "Member number:",
  "shell.menu.userChip.openProfile": "Open My info",
  "shell.primaryNav.koti": "Home",
  "shell.primaryNav.label": "Primary navigation",
  "shell.primaryNav.omatTiedot": "My info",
  "shell.primaryNav.unreadBadge": "Unread messages: {n}",
  "shell.primaryNav.viestit": "Messages",
  "shell.session.signingOut": "Signing out…",
  "shell.session.signOutFailed": "Sign-out failed. Your session may still be active. Please try signing out again.",
  "shell.session.retrySignOut": "Retry sign-out",
  "shell.session.accountReplaced": "Another account signed in on this browser. Reloading the page…",
  "shell.session.reload": "Reload the page",
  "shell.session.loading": "Checking sign-in…",
  "shell.skipLink.label": "Skip to main content",
  "shell.topBar.menuLabel": "Open menu"
}
